import { GridRowId } from '@mui/x-data-grid-pro';
import { TPlaneringRequiredFieldErrors } from './planeringRequiredValidationUtils';

export type TPlaneringRequiredFieldErrorsByRow = Record<
  string,
  TPlaneringRequiredFieldErrors
>;

export const clearPlaneringRequiredFieldErrorInState = (
  prev: TPlaneringRequiredFieldErrorsByRow,
  rowId: GridRowId,
  fieldName: keyof TPlaneringRequiredFieldErrors
): TPlaneringRequiredFieldErrorsByRow => {
  const rowKey = String(rowId);
  const rowErrors = prev[rowKey];
  if (!rowErrors || !rowErrors[fieldName]) {
    return prev;
  }

  const nextRowErrors = { ...rowErrors };
  delete nextRowErrors[fieldName];

  if (Object.keys(nextRowErrors).length === 0) {
    const { [rowKey]: _removed, ...rest } = prev;
    return rest;
  }

  return {
    ...prev,
    [rowKey]: nextRowErrors,
  };
};

export const setPlaneringRequiredFieldErrorInState = (
  prev: TPlaneringRequiredFieldErrorsByRow,
  rowId: GridRowId,
  fieldName: keyof TPlaneringRequiredFieldErrors,
  message: string
): TPlaneringRequiredFieldErrorsByRow => {
  const rowKey = String(rowId);
  const rowErrors = prev[rowKey] ?? {};

  if (rowErrors[fieldName] === message) {
    return prev;
  }

  return {
    ...prev,
    [rowKey]: {
      ...rowErrors,
      [fieldName]: message,
    },
  };
};
